import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { ProductForm } from '../../app/components/forms/product';
import { trpc } from '@org/clients/school';
import { unwrapTrpcData } from '@org/ui';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/products/$productId')({
  component: ProductDetailRoute,
});

function ProductDetailRoute() {
  const { productId } = Route.useParams();
  const navigate = useNavigate({ from: '/products/$productId' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');
  const { data, isLoading } = trpc.products.getById.useQuery({ productId });
  const product = unwrapTrpcData(data);

  const handleClose = () => {
    navigate({ to: '/products', replace: true });
  };

  const handleSubmit = async () => {
    await utils.products.list.invalidate();
    await utils.products.getById.invalidate({ productId });
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('products.list.modal.editTitle')}
      size="lg"
      centered
      body={
        isLoading ? (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('products.form.loading')}
          </div>
        ) : product ? (
          <ProductForm
            defaultValues={product}
            onSubmit={handleSubmit}
            onClose={handleClose}
          />
        ) : (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('products.form.notFound')}
          </div>
        )
      }
      footer={<></>}
    />
  );
}
